import { render } from "./MsgBar.vue?vue&type=template&id=ea8f7dfa&scoped=true"
import script from "./MsgBar.vue?vue&type=script&lang=js"
export * from "./MsgBar.vue?vue&type=script&lang=js"

import "./MsgBar.vue?vue&type=style&index=0&id=ea8f7dfa&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea8f7dfa"]])

export default __exports__